/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as actionTypes from './actionTypes';

const defaultStatus = {
  shouldShowError: false
};

export const reducer = (state = defaultStatus, action) => {
  switch (action.type) {
    case actionTypes.OPEN_SEARCH_SKILL:
      return { ...state, shouldShowError: true };
    case actionTypes.CLOSE_SEARCH_SKILL:
      return { ...state, shouldShowError: false };
    default:
      return state;
  }
};

export default reducer;
